import useStripeCustomers from "../Settings/useStripeCustomers";
import dayjs from "dayjs";
import { BillingTier } from "@prisma/client";

/**
 * Hook that returns the data for the automations widget
 *
 * @returns
 *  loading - loading status true or false
 */
export type PaywallState = {
  loadingPlanTier: boolean;
  trialing: boolean;
  userPlanTier: BillingTier;
};

export function usePaywall(): PaywallState {
  const guildId = localStorage.getItem("guild-id");
  const { isLoading, billingCustomer } = useStripeCustomers(guildId);
  if (isLoading)
    return {
      loadingPlanTier: isLoading,
      trialing: false,
      userPlanTier: "free",
    };
  else if (billingCustomer) {
    // if in trial, return trial data
    if (billingCustomer.trial_end > dayjs().toISOString()) {
      return {
        loadingPlanTier: isLoading,
        trialing: true,
        userPlanTier: billingCustomer.trial_tier,
      };
    } else {
      // else return non-trial status if active, else return free
      return {
        loadingPlanTier: isLoading,
        trialing: false,
        userPlanTier:
          billingCustomer.status === "active" ? billingCustomer.tier : "free",
      };
    }
  } else {
    console.log("error getting billingCustomer in usePaywall");
    return {
      loadingPlanTier: isLoading,
      trialing: false,
      userPlanTier: "free",
    };
  }
}
